export default [
  require("/home/runner/work/rxdb/rxdb/docs-src/node_modules/@docusaurus/plugin-google-gtag/lib/gtag"),
  require("/home/runner/work/rxdb/rxdb/docs-src/node_modules/infima/dist/css/default/default.css"),
  require("/home/runner/work/rxdb/rxdb/docs-src/node_modules/@docusaurus/theme-classic/lib/prism-include-languages"),
  require("/home/runner/work/rxdb/rxdb/docs-src/node_modules/@docusaurus/theme-classic/lib/nprogress"),
  require("/home/runner/work/rxdb/rxdb/docs-src/src/css/custom.css"),
];
